import { useMutation, MutationHookOptions } from "@apollo/client";
import mutationGQL from "@/Apollo/mutation/createFavoriteProduct.graphql";

import {
  CreateFavoriteMutation,
  CreateFavoriteMutationVariables,
} from "@/Apollo/schema";
import { evictFavoritesList } from "@/common/utils/mutation.utils";

export const useCreateFavoriteProduct = (
  options?: MutationHookOptions<
    CreateFavoriteMutation,
    CreateFavoriteMutationVariables
  >
) => {
  return useMutation<CreateFavoriteMutation, CreateFavoriteMutationVariables>(
    mutationGQL,
    {
      ...options,
      /* Composed, not overridden — callers pass their own `update` to patch the product itself. */
      update: (cache, result, context) => {
        evictFavoritesList(cache);
        options?.update?.(cache, result, context);
      },
    }
  );
};
